import React, { useState, useEffect } from "react";
import { Typography, Grid } from "@mui/material";
import { MDBCarousel, MDBCarouselItem } from "mdb-react-ui-kit";
import Firestore from "../firebase/FireStore";

function Sales() {
  const [products, setProducts] = useState(null);
  useEffect(() => {
    async function fetchData() {
      let new_products = await Firestore.getAllItems();
      setProducts([...new_products.val]);
    }
    fetchData();
  }, [products]);
  return (
    <div>
      <Typography
        variant="h2"
        sx={{
          marginLeft: { md: "50px" },
          textAlign: { md: "left", xs: "center" },
          marginTop: "40px",
        }}
      >
        Sale
      </Typography>
      <Grid
        container
        gap={{ md: 20, xs: 1 }}
        className="mt-1 flex items-center justify-center"
      >
        <Grid
          item
          xs={11}
          md={4}
          sx={{
            backgroundColor: "grey",
            backgroundImage: "url(/Images/sales.jpg)",
            backgroundSize: "cover",
            backgroundPosition: "center center",
            height: "600px",
          }}
        ></Grid>
        <Grid item xs={11} md={3.5} sx={{ height: "600px" }}>
          <MDBCarousel showControls fade showIndicators>
            {products != null
              ? products.map((product) => (
                  <MDBCarouselItem
                    className="w-100 d-block"
                    style={{
                      height: "550px",
                      width: "auto",
                      objectFit: "cover",
                    }}
                    itemId={1}
                    src={product.image}
                    alt="..."
                  />
                ))
              : null}
          </MDBCarousel>
        </Grid>
      </Grid>
    </div>
  );
}

export default Sales;
